var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "arrow-right"
}, /*#__PURE__*/React.createElement("path", {
  id: "Primary",
  d: "M18.7688 12.5438C18.9156 12.4032 19 12.2063 19 12.0001C19 11.7938 18.9156 11.6001 18.7688 11.4563L13.2688 6.20633C12.9688 5.91883 12.4938 5.93133 12.2094 6.23133C11.925 6.53133 11.9344 7.00633 12.2344 7.2907L16.3781 11.2501H5.75C5.33437 11.2501 5 11.5845 5 12.0001C5 12.4157 5.33437 12.7501 5.75 12.7501H16.3781L12.2312 16.7063C11.9312 16.9938 11.9219 17.4657 12.2063 17.7657C12.4906 18.0657 12.9656 18.0751 13.2656 17.7907L18.7656 12.5407L18.7688 12.5438Z",
  fill: "currentColor"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ec6f55f9a0862abc7ecd30726f2e7a3d.svg";